import axios from 'axios';

const client = axios.create();
client.defaults.baseURL = process.env.API_TIKTOK;

export default client;



// WEBPACK FOOTER //
// ./src/api/tiktok.js